/**
 * Which tile the idea's Media panel gives each media type, and how wide that
 * type's grid track is. Pure; no React.
 *
 * Lives outside the JSX because this repo has no render-test harness (see
 * `components/Header/__tests__/Header.stories-tab.test.tsx`), so a routing rule
 * embedded in a component is unassertable. The rule is TD-001: non-thumbnail
 * media uses AudioMediaCard. Routing audio to the thumbnail tile instead makes
 * MediaDisplay fall through to its "Unknown media type" placeholder.
 */

export type MediaType = "photo" | "video" | "audio";

export type TileKind = "thumbnail" | "audio";

/** Audio carries no thumbnail, so it gets the audio tile (TD-001). */
export function tileFor(mediaType: MediaType): TileKind {
  return mediaType === "audio" ? "audio" : "thumbnail";
}

/**
 * Audio tiles are horizontal rows carrying a filename, size and duration, so
 * they need a wider column than a square thumbnail. The library sizes them at
 * 200-320px; three columns at panel width is the equivalent.
 */
export function gridClassFor(mediaType: MediaType): string {
  return tileFor(mediaType) === "audio"
    ? "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-3"
    : "grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-3";
}
